import React from "react"
import { View } from "react-native"
import styles from "./styles"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { RFValue } from "react-native-responsive-fontsize"
import { baseFontFamily } from "@Constants/baseStyles"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import SavoirEtreTopTabStack from "@Navigation/TopTabBarStack/SavoirEtreTopTabStack/SavoirEtreTopTabStack"

const SavoirEtre = (props) => {
    const { navigation } = props
    const navigateTo = (nextScreen) => navigation.navigate(nextScreen)

    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <BreeSerifText style={styles.headerTile} fontSize={RFValue(24)}>
                    Savoir-Être
                </BreeSerifText>

                <OpenSansText defaultFontFamily={baseFontFamily.OpenSansSemiBold} fontSize={RFValue(16)}>
                    Retrouvez des vidéos et notre forum de discussion avec d’autres utilisateurs.
                </OpenSansText>
            </View>
            <SavoirEtreTopTabStack />
        </View>
    )
}

export default SavoirEtre
